import { render, staticRenderFns } from "./BasicFilter.vue?vue&type=template&id=a54133d2&scoped=true"
import script from "./BasicFilter.vue?vue&type=script&lang=js"
export * from "./BasicFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54133d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a54133d2')) {
      api.createRecord('a54133d2', component.options)
    } else {
      api.reload('a54133d2', component.options)
    }
    module.hot.accept("./BasicFilter.vue?vue&type=template&id=a54133d2&scoped=true", function () {
      api.rerender('a54133d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/filters/BasicFilter.vue"
export default component.exports